import {useTranslate as useTranslateOrig, useTolgee, TranslationKey} from "@tolgee/react";
import {useCallback} from "react";

const GIBBERISH =
  "♠♣♥♦♪♫☀☁☂☃ ★☆☾☽ ☼☽☾ ☯ ☮☭✈✉♠♣ ♥♦♪♫ ☀☁☂☃★☆☾☽☼☽☾☯ ☮☭ ✈✉♠♣♥ ♦ ♪♫☀☁☂☃ ★☆☾☽ ☼☽☾☯☮ ☭✈✉♠♣♥♦♪♫ ☀☁ ☂☃★☆☾☽☼ ☽☾☯☮☭ ✈✉";

export function deriveDefaultValueFromKeyName(keyName: string): string | undefined {
  if (keyName.startsWith("c.")) {
    const disambiguation = keyName.indexOf("[");
    return keyName.substring(2, disambiguation !== -1 ? disambiguation : undefined).replaceAll("_", " ");
  }
  return undefined;
}

export function deriveGibberishFromKeyName(keyName: string): string {
  let len = 50;
  if (keyName.startsWith("c.")) {
    len = (keyName.length - keyName.indexOf("[")) / 2;
  }
  return GIBBERISH.substring(0, Math.min(len, GIBBERISH.length));
}

export default function useTranslate() {
  const {t} = useTranslateOrig();
  const tolgee = useTolgee(["language"]);
  const language = tolgee.getLanguage();
  return useCallback(
    (keyName: TranslationKey, defaultValue?: string, params?: Record<string, string | number | bigint>) => {
      if (language === "xx") {
        return deriveGibberishFromKeyName(keyName);
      }
      return t(keyName, defaultValue ?? deriveDefaultValueFromKeyName(keyName), {
        // By default Tolgee adds zero width non-breaking spaces to translations in dev mode, for
        // reasons best known to the Tolgee devs. We disable that here because it breaks forms
        // and presumably the reason the caller is using this function rather than the `<T>` component
        // is to get a plain unadulterated string.
        noWrap: true,
        ...params,
      });
    },
    [t, language],
  );
}
